export default __webpack_public_path__ + "static/media/cheveron.53e52161.svg";